import './visio-qualification-actions.component.ajscss';

import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './visio-qualification-actions.component.html';

const MODULE_NAME = 'cngVisioQualificationActions';

export class VisioQualificationActionsCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  canRenewPostTreatment = false;
  canFinishPostTreatment = false;

  constructor(private readonly qualificationDeprecatedService: IQualificationDeprecatedService) {}

  $onInit() {
    this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(can => (this.canRenewPostTreatment = can));
    this.qualificationDeprecatedService
      .canFinishPostTreatment(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(can => (this.canFinishPostTreatment = can));
  }

  finishQualification(): void {
    this.qualificationDeprecatedService.finishQualification(this.responseId);
  }

  renewPostTreatment(): void {
    this.qualificationDeprecatedService.renewPostTreatment(this.responseId).then(() => {
      this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(canRenew => {
        this.canRenewPostTreatment = canRenew;
      });
    });
  }
}

export class VisioQualificationActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['qualificationDeprecatedService', VisioQualificationActionsCtrl];
}

export default MODULE_NAME;
